import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import news from './news'
import reports from './reports'
import avhandlingar from './avhandlingar'
import pages from './pages'
import content from './content'
import tags from './tags'
import links from './links'
import image from './images'
import arter from './arter'
import arterFacts from './arterFacts'
import memo from './memo'
import user from './user'
import contacts from './contacts'
import searchLogs from './searchLogs'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    auth: auth('auth'),
    user: user('user'),
    news: news('news'),
    newsOffline: news('news'),
    reports: reports('article'),
    avhandlingar: avhandlingar('article'),
    pages: pages('pages'),
    content: content('content'),
    tags: tags('tag'),
    links: links('link'),
    image: image('image'),
    imageSearch: image('image'),
    arter: arter('art'),
    arterFacts: arterFacts('ArtFact'),
    memo: memo('memo'),
    contacts: contacts('contact'),
    searchLogs: searchLogs('searchLogs'),
  },
})
